import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const EditableTextarea = styled.textarea`
  width: 100%;
  padding: ${({ theme }) => pxToRem(theme.spacing.xs)} ${({ theme }) => pxToRem(theme.spacing.sm)};
  border: none;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: none;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 400;
  outline: none;
  resize: none;
  overflow: hidden;

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;
